import {BBModel} from '../bb_model';
import {bbTimeZone} from '../utils/time_zone';
import {roles} from '..';

class BBAuthorisation {

    constructor() {
        this.user = null;
        this.company = null;
        this.person = null;
    }

    getUser() {
        return this.user;
    }

    setUser(user) {
        if (user && !(user instanceof BBModel.Admin.User)) {
            throw new Error('not instance of BBModel.Admin.User');
        }

        this.setCompany(null);

        this.user = user;

        if (this.user) {
            this.user.setParentRole(false);
        }
    }

    getPerson() {
        return this.person;
    }

    async ensurePerson() {
        if (this.user.$has('person')) {
            try {
                this.person = await this.user.$getPerson();
            } catch (error) {
                console.error('could not fetch person', error);
            }
        }

        return this.person;
    }

    getCompany() {
        return this.company;
    }

    async setCompany(company) {

        if (company && !(company instanceof BBModel.Admin.Company)) {
            throw new Error('not instance of BBModel.Admin.Company');
        }

        this.company = company;

        if (this.company) {
            bbTimeZone.setCompany(company.timezone);
            this.user.setParentRole(this.company.hasChildren());
            await this.company.postCreationInitialisation();
        }
    }

    clearAll() {
        this.user = null;
        this.company = null;
        this.person = null;
    }

    setAccess(user, company) {
        this.setUser(user);
        return this.setCompany(company);
    }

    async isMultiLocation() {

        if (!this.getUser()) {
            throw new Error('user not defined');
        }

        if (!this.getCompany()) {
            throw new Error('company not defined');
        }

        let baseLogin, administrators;

        try {
            await this.getUser().$flush('base_login');
            baseLogin = await this.getUser().$getBaseLogin();
        } catch (err) {
            throw new Error('could not fetch base login');
        }

        try {
            administrators = await baseLogin.$getAdministrators();
            administrators = administrators.filter(admin => !admin.company_cancelled);
        } catch (err) {
            throw new Error('could not fetch base administrators');
        }

        if (administrators.length > 1 || administrators[0].company_id !== this.getCompany().id) {
            return true;
        }

        return this.getCompany().hasChildren() && this.getUser().getOriginalRole() !== roles.callCenter && !this.getUser().$has('person');
    }
}

const bbAuthorisation = new BBAuthorisation();

export {
    bbAuthorisation
};
